export { ClipboardIcon } from "./ClipboardIcon";
export { DepositIcon } from "./DepositIcon";
export { FAQIcon } from "./FAQIcon";
export { FilterIcon } from "./FilterIcon";
export { ShopsIcon } from "./ShopsIcon";
export { GoldBarsIcon } from "./GoldBarsIcon";
export { HomeIcon } from "./HomeIcon";
export { IdentificationIcon } from "./IdentificationIcon";
export { NewsIcon } from "./NewsIcon";
export { OrdersIcon } from "./OrdersIcon";
export { P2POrdersIcon } from "./P2POrdersIcon";
export { PaymentIcon } from "./PaymentIcon";
export { ProductIcon } from "./ProductIcon";
export { ProductOrdersIcon } from "./ProductOrdersIcon";
export { SolutionsIcon } from "./SolutionsIcon";
export { TransactionsIcon } from "./TransactionsIcon";
export { TransferIcon } from "./TransferIcon";
export { UploadIcon } from "./UploadIcon";
export { WalletIcon } from "./WalletIcon";
export { WhitepaperIcon } from "./WhitepaperIcon";
export { WithdrawIcon } from "./WithdrawIcon";
export { SelfieIcon } from "./SelfieIcon";
export { IxSendIcon } from "./IxSendIcon";
export { ResetIcon } from "./ResetIcon";
export { DisputesIcon } from "./DisputesIcon";
export { AssignUserIcon } from "./AssignUserIcon";
export { AssignCheckIcon } from "./AssignCheckIcon";
export { LeaderboardIcon } from "./LeaderboardIcon";
export * from "./SupportIcon";
